import React, { CSSProperties } from 'react'
import './styles.css'

export const PulsingCircle = ({ style }: { style?: CSSProperties }) => (
  <div style={style} className="pulsating-circle"></div>
)
